import { render } from "./FixedFooter.vue?vue&type=template&id=aa50f4d0&scoped=true"
import script from "./FixedFooter.vue?vue&type=script&lang=ts"
export * from "./FixedFooter.vue?vue&type=script&lang=ts"

import "./FixedFooter.vue?vue&type=style&index=0&id=aa50f4d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aa50f4d0"

export default script